export const followupFieldLabels = {
  id: 'Identifiant',
  beneficiaryId: 'Bénéficiaire',
  familyFileId: 'Dossier',
  subjects: "Objet(s) de l'accompagnement",
  medium: "Type d'entretien",
  documents: 'Documents',
  status: 'Statut',
  date: 'Date de saisie',
  dueDate: "Date d'échéance ou de rappel",
  place: 'Lieu de rendez-vous',
  thirdPersonName: 'Tierce personne',
  synthesis: 'Compte rendu',
  privateSynthesis: 'Compte rendu privé',
  helpRequested: 'Instruction de dossier',
  classified: 'Classé',
  firstFollowup: '1er entretien',
  endOfSocialSupport: "Fin d'accompagnement",
  forwardedToJustice: 'Transmis à la justice',
  isDuringWalkInSession: 'Entretien réalisé en permanence',
  minister: 'Ministre',
  ministerId: 'Ministre',
  numeroPegase: 'Numéro Pégase',
  prescribingOrganizationId: 'Organisme prescripteur',
  prescribingOrganizationContactId: "Contact de l'organisme prescripteur",
  updated: 'Dernière mise à jour',
  createdById: 'Agent',
  lastUpdatedById: 'Modifié par',
  duration: "Durée de l'entretien",
  partnerOrganizationId: "Nom de l'organisme",
  externalStructureName: 'Nom structure / personne',
  supportProgramId: "Dispositif ou axe d'intervention"
}
